import React from "react";

export const VideoPlayer = ({ videoUrl }) => {
    return (
        <video controls width="1072px" style={{ borderRadius: "2px" }} controlsList="nodownload">
            <source src={videoUrl} type="video/mp4" />
            Your browser doesn't support the video tag
        </video>
    );
}